export enum ErrorMessage {
  DecodedSession = 'Error when decode session',
  GetStateSession = 'Error get state session',
  GetUserSession = 'Error get user session',
  SetUserSession = 'Error update user session',
  DeleteUserSession = 'Error delete user session',
}
